import EDate from '$/shared/frontend/utils/EDate';
import { useTeamNextPaymentDueDateQuery } from '$/GraphQL/schema/schema';

export const useNextPaymentDueDate = () => {
  const { data } = useTeamNextPaymentDueDateQuery({
    nextFetchPolicy: 'cache-first',
  });
  const nextPaymentDueDate = data?.myTeam?.nextPaymentDueDate;
  const nextPaymentDueDateText = nextPaymentDueDate
    ? new EDate(nextPaymentDueDate).format('P')
    : 'the date the billing cycle ends';
  return {
    nextPaymentDueDate,
    nextPaymentDueDateText,
  };
};
